import { createBuilderModule } from '../../../builder';
import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { PopularTemplatesSection } from './PopularTemplatesSection';
import { DEFAULT_VALUES } from './fixtures';
import { COLOR_KEYS } from '../../../constants';

export default createBuilderModule(
  withTracking(PopularTemplatesSection, {
    as: 'section',
    sectionName: SectionName.PopularTemplatesSection,
  }),
  {
    name: 'PopularTemplatesSection',
    image: 'https://cdn.zappy.app/9428f7ba38c34640ffa27b9834437180.png',
    inputs: [
      {
        name: 'title',
        helperText: 'Section title',
        type: 'string',
        defaultValue: DEFAULT_VALUES.title,
        required: true,
      },
      {
        name: 'backgroundColor',
        type: 'string',
        enum: [
          COLOR_KEYS.blue10,
          COLOR_KEYS.cream,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral200,
        ],
        required: true,
        defaultValue: DEFAULT_VALUES.backgroudColor,
      },
      {
        name: 'defaultCtaHref',
        helperText:
          'Destination link for CTA button/link when a role is not selected',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.defaultCtaHref,
      },
      {
        name: 'ctaButtonText',
        helperText: 'Text for the CTA button',
        type: 'string',
        required: true,
        defaultValue: DEFAULT_VALUES.ctaButtonText,
      },
      {
        name: 'defaultTemplates',
        helperText:
          'Templates displayed when no role is selected. If none is input, an API call will return the most popular templates for all roles.',
        type: 'list',
        subFields: [
          {
            name: 'title',
            type: 'string',
            required: true,
            defaultValue: 'Title',
          },
          { name: 'url', type: 'string', required: true, defaultValue: '#' },
          {
            name: 'services',
            type: 'list',
            required: true,
            subFields: [
              { name: 'image', type: 'string', required: true },
              { name: 'name', type: 'string', required: true },
            ],
            defaultValue: [
              {
                image:
                  'https://cdn.zappy.app/9428f7ba38c34640ffa27b9834437180.png',
                name: 'Templates logo',
              },
            ],
          },
        ],
      },
      {
        name: 'roles',
        type: 'list',
        defaultValue: DEFAULT_VALUES.roles,
        subFields: [
          { name: 'name', type: 'string', required: true },
          {
            name: 'href',
            type: 'string',
            required: true,
            helperText: 'Destination href for individual job role',
          },
          {
            name: 'canonicalId',
            helperText:
              'ID used to fetch the templates for the role from the Zapier API. If none is input, you must manually add templates for the role.',
            type: 'string',
          },
          {
            name: 'templates',
            type: 'list',
            subFields: [
              { name: 'title', type: 'string', required: true },
              { name: 'url', type: 'string', required: true },
              {
                name: 'services',
                type: 'list',
                required: true,
                subFields: [
                  { name: 'image', type: 'string', required: true },
                  { name: 'name', type: 'string', required: true },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
);
